module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductPurchasedPerMonthBanner":{"message":"Letos zakoupilo {0} zákazníků"}},"de":{},"sk":{}}')
  delete Component.options._Ctor
}
